import { put, call, takeLatest } from 'redux-saga/effects'
import {
  REQUEST_DELIVERY_DATA, REQUEST_DELIVERY_UNSUBSCRIPTION_DATA
} from '../constants/deliveryConstant'
import {
  setDeliveryData
} from '../actions/deliveryAction'
import { setLoadingState, setErrorMessage } from '../actions/commonAction'

function * requestDeliveryData (action) {
  let { id } = action.payload
  yield put(setLoadingState({ loading: true }))
  let request = () => {
    // 查询商品数据
    let config = { url: window.API.Transaction.getHoldOrderDetails(id) }
    return window.axios.request(config)
  }
  let request2 = (productId) => {
    // 某些商品一套，拆成单件来提货，调这个接口来查询单件单价，不要再自己计算单价
    let config = {
      url: window.API.Delivery.getDeliveryPrice,
      method: 'post',
      data: {
        orderNum: id,
        deliveryNumber: -1,
        addressId: 1,
        productId
      }
    }
    return window.axios.request(config)
  }
  try {
    let detailsData = yield call(request)
    let { productId } = detailsData
    if (productId === '' || productId === undefined) {
      yield put(setErrorMessage(`商品ID获取错误[${productId}]`))
    } else {
      let priceData = yield call(request2.bind(this, productId))
      yield put(setLoadingState({ loading: false }))
      yield put(setDeliveryData({ detailsData, priceData }))
    }
  } catch (error) {
    yield put(setErrorMessage(error.message))
  }
}

function * requestDeliveryUnsubscriptionData (action) {
  let { id } = action.payload
  yield put(setLoadingState({ loading: true }))
  let request = () => {
    // 查询商品数据
    let config = { url: window.API.Transaction.getHoldOrderDetails(id) }
    return window.axios.request(config)
  }
  let request2 = (productId) => {
    // 某些商品一套，拆成单件来提货，调这个接口来查询单件单价，不要再自己计算单价
    let config = {
      url: window.API.Delivery.getDeliveryUnsubscriptionPrice,
      method: 'post',
      data: {
        orderNum: id,
        deliveryNumber: -1,
        addressId: 1,
        productId
      }
    }
    return window.axios.request(config)
  }
  try {
    let detailsData = yield call(request)
    let { productId } = detailsData
    if (productId === '' || productId === undefined) {
      yield put(setErrorMessage(`商品ID获取错误[${productId}]`))
    } else {
      let priceData = yield call(request2.bind(this, productId))
      priceData['productPrice'] = priceData['actualProductAmount']
      yield put(setLoadingState({ loading: false }))
      yield put(setDeliveryData({ detailsData, priceData }))
    }
  } catch (error) {
    yield put(setErrorMessage(error.message))
  }
}

export function deliverySaga () {
  return [
    takeLatest(REQUEST_DELIVERY_DATA, requestDeliveryData),
    takeLatest(REQUEST_DELIVERY_UNSUBSCRIPTION_DATA, requestDeliveryUnsubscriptionData)
  ]
}